<template>
  <div class="comment">
    <comment-form
      :post-id="postId"
      :id="commentData.id"
      :old-content="commentData.body"
      :is-new="false"
      v-if="isEditing"
      @update-data="onUpdateData"
      @close-form="onCloseForm"
    />

    <div class="comment__data" v-if="!isEditing">
      <router-link
        class="comment__avatar"
        :to="{
          name: 'UserProfile',
          params: { link: commentData.author.link },
        }"
      >
        <el-avatar :size="32">
          <user-avatar :userId="commentData.author.userId" :alt="commentData.author.firstName + ' ' + commentData.author.lastName" />
        </el-avatar>
      </router-link>

      <div class="comment__content">
        <!--router-link
          class="comment__user-name"
          :to="{
            name: 'UserProfile',
            params: { link: commentData.author.link },
          }"
        >
          {{ commentData.author.firstName }}
          {{ commentData.author.lastName }}
        </router-link-->
        <div class="comment__text">
          {{ commentData.body }}
        </div>
        <!--div class="comment__date">
          {{
            formatDate(
              commentData.createdOn,
              SHORT_DATETIME_FORMAT,
            )
          }}
        </div-->
        <!-- TODO reply on comment -->
      </div>

      <div class="comment__report" v-if="!commentData.canEdit">
        <el-link type="info">Report</el-link>
      </div>

      <div class="comment__controls" v-if="commentData.canEdit">
        <el-button
          type="primary"
          @click="editComment"
        >
          <el-icon><Edit/></el-icon>
        </el-button>
        <el-button
          type="primary"
          @click="requestDeleteComment"
          :disabled="
            isButtonDisabled(
              `delete-comment-${commentData.id}`,
            )
          "
        >
          <el-icon><Close/></el-icon>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { deleteComment } from '@/api/blog.js'
import { showMessage } from '@/utils/messages.js';
import { SHORT_DATETIME_FORMAT, formatDate } from '@/utils/index.js';
import { disableButton } from '@/mixins/disableButton.js';

import CommentForm from '@/components/common/CommentForm.vue';
import UserAvatar from '@/components/profile/UserAvatar.vue';

export default {
  name: 'PostComment',
  props: {
    commentData: {
      type: Object,
      required: true,
    },
    postId: {
      type: Number,
      required: false,
    },
    commentId: {
      type: Number,
      required: false,
    },
  },
  mixins: [disableButton],
  components: {
    CommentForm,
    UserAvatar
  },
  data() {
    return {
      isEditing: false,
      SHORT_DATETIME_FORMAT,
    };
  },
  methods: {
    showMessage,
    formatDate,
    async requestDeleteComment() {
      const { commentId } = this;
      this.disableButton(`delete-comment-${commentId}`);

      //console.log(commentId);

      const { success } = await deleteComment( commentId );
      this.enableButton(`delete-comment-${commentId}`);

      if (success) {
        this.$emit('update-data');
        this.showMessage({
          type: 'success',
          message: 'The comment has been removed',
        });
      }
    },
    editComment() {
      this.isEditing = true;
    },
    cancelEditing() {
      this.isEditing = false;
    },
    onUpdateData() {
      this.$emit('update-data');
    },
    onCloseForm() {
      this.isEditing = false;
    },
  },
};
</script>

<style lang="scss">
.comment {
  &__data {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    line-height: 1.6;
  }
  &__avatar {
    margin-right: var(--global-dimension-size-125);
    line-height: 1;
  }

  &__content {
    flex-grow: 1;
  }

  &__user-name {
    margin-bottom: var(--global-dimension-size-75);
    font-weight: 500;
    font-size: var(--font-size-200);
    color: var(--color-gray-900);
  }

  &__text {
    margin-bottom: var(--global-dimension-size-75);
    font-size: var(--font-size-100);
  }

  &__date {
    font-size: var(--font-size-75);
    color: var(--color-gray-700);
  }

  &__report {
  }
}
</style>
